import React, { useState } from "react";
import "./segmentedControl.css";

interface Option {
  id: number;
  label: string;
  value: string;
}

export default function SegmentedControl({
  size = "large",
  options = [],
  defaultOpt = 0,
  callback,
}: {
  size?: "large" | "small";
  options: Option[];
  defaultOpt?: number;
  callback?: (val: string) => void;
}) {
  const [selectedIdx, setSelectedIdx] = useState(defaultOpt);

  const handleChange = (value: string, index: number) => {
    setSelectedIdx(index);
    if (callback) callback(value);
  };
  return (
    <>
      <div className={`seg-ctrl__wrapper ${size}`}>
        {options.map((opt, idx) => (
          <div
            className={`seg-ctrl__opt ${size} ${
              selectedIdx === opt.id && "selected"
            }`}
            key={opt.id}
            onClick={() => {
              handleChange(opt.value, idx);
            }}
          >
            {opt.value}
          </div>
        ))}
      </div>
    </>
  );
}
